<template>
  <app-cells position="between">
    <div>
      <paginate
        v-if="pages > 1"
        :value="page"
        :click-handler="value => $emit('change', value)"
        :page-count="pages"
        :prev-text="'<'"
        :next-text="'>'"
        :container-class="'pagination'"
        :page-class="'pagination__item'"
        :page-link-class="'pagination__link'"
        :prev-class="'pagination__item pagination__item--prev'"
        :next-class="'pagination__item pagination__item--next'"
        :next-link-class="'pagination__link pagination__link--next'"
        :prev-link-class="'pagination__link pagination__link--prev'"
      />
    </div>
    <app-table-records :all="count" :count="length" :page="page" :limit="pageSize" />
  </app-cells>
</template>

<script>
import { PAGE_SIZE } from './funding'

export default {
  name: 'FundingPagination',
  props: {
    page: { type: Number, required: true },
    count: { type: Number, required: true },
    length: { type: Number, required: true },
  },
  data() {
    return { pageSize: PAGE_SIZE }
  },
  computed: {
    pages() {
      return Math.ceil(this.count / this.pageSize)
    },
  },
}
</script>
